export default __webpack_public_path__ + "static/media/ordinals-circle.b47b11dc.png";